import React, { useEffect, useRef, useState } from 'react';
import { useFormGeneratorField } from '../hooks/useFormGeneratorField';
import UniFormcompoErrorInField from './UniFormcompoErrorInField';

const UniFormgenSelect = (props) => {
  const timeoutRef = useRef(null);
  const [clAnimation, setClAnimation] = useState("");

  const {
    warningtip,
    valueToDisplay,
  } = useFormGeneratorField(props);

  //
  let params = {};
  if (props.params) {
    params = props.params;
  }
  let withoutdefaultoption = false;
  if (params.withoutdefaultoption === true) {
    withoutdefaultoption = true;
  }
  let disabled = false;
  if (params.disabled === true) {
    disabled = true;
  }
  let readonly = false;
  if (params.readonly === true) {
    readonly = true;
    disabled = true; //
  }
  let name = 'unnamed';
  if (typeof params.name === 'string' && params.name !== '') {
    name = params.name;
  }
  let formState = {};
  if (props.formState) {
    formState = props.formState;
  }
  let formErrors = {};
  if (props.formErrors) {
    formErrors = props.formErrors;
  }

  useEffect(() => {
    // animate when value change
    setClAnimation(" uniformcompo__field--animate-value-changed");
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      //
      setClAnimation("");
    }, 334);
    // componentWillUnmount
    return () => clearTimeout(timeoutRef.current);
  }, [formState[name]]);


  let handleChange = null;
  if (typeof props.handleChange === 'function') {
    handleChange = props.handleChange;
  }
  if (readonly === true) {
    // FIX (According to HTML specs, the select tag in HTML doesn't have a readonly attribute, only a disabled attribute.)
    // handleChange = () => { }; // disable handle change for readonly
    handleChange = null; // disable handle change for readonly
  }

  let _handleChange = (e) => {
    // console.log('*** menjamo SELECT');
    if (params.valuetype === "number") {
      let _value;
      if (params.integer === true) {
        _value = Number.parseInt(e.target.value); // INTEGER
      } else {
        _value = Number.parseFloat(e.target.value); // FLOAT DEFAULT
      }
      let virtual_e = {
        target: {
          name: e.target.name,
          value: _value
        }
      }
      // console.log(virtual_e);
      handleChange(virtual_e);
    } else { // regular handleChange
      // console.log(e);
      handleChange(e);
    }
  }

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  let cl = 'uniformcompo__field' + clAnimation + extraClass;
  if (typeof formErrors[name] === 'string' && formErrors[name] !== '') {
    cl += ' error';
  }

  let style = {};
  if (params.w > 0) {
    style.width = params.w;
  }

  // options
  let list = params.options;
  let jsxSelectOptions = null;
  if (Array.isArray(list)) {
    jsxSelectOptions = list.map((item) => {
      let value, title;
      if (typeof item === 'string') {
        value = item;
        title = item;
      } else {
        value = item.value;
        title = item.title;
      }
      return (
        <option key={value} value={value}>{title}</option>
      );
    });
  }

  let infotip = 'name: ' + name;
  if (params.valuetype === "number") {
    infotip = 'name: ' + name + ' (number)';
  }

  let custom_default_option = '--Izaberi opciju--';
  if (typeof params.default_option_title === 'string') {
    custom_default_option = params.default_option_title;
  }

  // OLD value={formState[name] === null ? '' : formState[name]}
  // FIX value={formState[name] === null ? '' : formState[name]}
  return (
    <div className={cl} style={style}>
      <label htmlFor={name}>{params.label}</label>
      <UniFormcompoErrorInField error={formErrors[name]} />
      <div className="uniformcompo__field__infotip-container"><div className="uniformcompo__field__infotip">{infotip}</div></div>
      {
        warningtip ? (
          <div className="uniformcompo__field__warningtip-container"><div className={"uniformcompo__field__warningtip" + (" frfr-js-tinytag frfr-js-tinytag--primitive-value-type--" + warningtip)}>{warningtip}</div></div>
        ) : null
      }

      <select
        disabled={disabled}
        name={name}
        value={(formState[name] === null || typeof formState[name] === 'undefined') ? '' : formState[name]}
        onChange={_handleChange}
      >
        {
          withoutdefaultoption ? (null) : (
            <option value={''}>{custom_default_option}</option>
          )
        }
        {jsxSelectOptions}
      </select>
    </div>
  );
};

export default UniFormgenSelect;